<template>
  <div id="super_agi_email_activity_analytics" class="flex flex-col gap-2">
    <EmailAnalyticsGrid />
    <EmailCampaignsPerformance />
    <EmailActivityFunnel />
    <EmailEngagementActivity />
  </div>
</template>

<script setup>
import EmailAnalyticsGrid from "@/src/views/analytics/v2/superagi_activity_analytics/email/EmailAnalyticsGrid.vue";
import EmailActivityFunnel from "@/src/views/analytics/v2/superagi_activity_analytics/email/EmailActivityFunnel.vue";
import EmailEngagementActivity from "@/src/views/analytics/v2/superagi_activity_analytics/email/EmailEngagementActivity.vue";
import EmailCampaignsPerformance from "@/src/views/analytics/v2/superagi_activity_analytics/email/EmailCampaignsPerformance.vue";
</script>
